import React from 'react';
import { useSelector } from 'react-redux';
import LoadingCircle from '@cpg-its/ads.common.loading-circle';
import Banner from '@cpg-its/ads.containers.banner';
import { TcsmStates } from '../../root/tcsm-model';
import { WysiwygWithReactLink } from '../../global/components/wysiwyg-with-react-link';
import { ContentSpacer } from '../../global/components/layout/generic-content-spacer';
import { MyCPGMidYearProps } from '../account-info/features/mycpg-midyear/models/mycpg-midyear-epi-props';
import { TcsmAppConfigs } from '../../global/models/configuration-models';
import { useMyCPGMidYearSettings } from '../account-info/features/mycpg-midyear/hooks/useMyCPGMidyearSettings';
import { useMyCpgMidYearOpenEnrollments } from '../../global/hooks/useMyCpgMidYearOpenEnrollments';
import { QualifyingEventType } from '../account-info/features/mycpg-midyear/models/mycpg-mid-year-models';


interface Props {
	appConfig: TcsmAppConfigs;
}
export function MyCpgMidYearNotification(props: Props) {
	const { appConfig } = props;

	const settingsLoaded = useMyCPGMidYearSettings(appConfig.myCpgMidYearSettingsId);
	const openEnrollments = useMyCpgMidYearOpenEnrollments();
	const midYearSettings = useSelector<TcsmStates, MyCPGMidYearProps>(state => state?.epiProps?.myCpgMidyearSettingsState?.epiContent);

	const getEventName = (event: QualifyingEventType) => {
		return midYearSettings?.qualifyingEventPageContents?.find(e => e?.eventType === event)?.pageTitle;
	};

	if (!settingsLoaded) {
		return <LoadingCircle />;
	}



	return (
		<>
			{
				openEnrollments?.map(enrollment =>
					<ContentSpacer>
						<Banner
							key={enrollment?.id}
							banner={{
								type: 'warning',
								label: <WysiwygWithReactLink className='input-label' content={midYearSettings?.openEnrollmentAlertTitle?.replace('[life_event_name]', getEventName(enrollment?.qualifying_event as QualifyingEventType))?.replace('[date]', enrollment?.complete_by)} />,
								description: <WysiwygWithReactLink content={midYearSettings?.openEnrollmentAlertDescription?.replace('[date]', enrollment?.complete_by)} />,
							}}
						/>
					</ContentSpacer>)

			}
		</>
	);

}